import { render, staticRenderFns } from "./toDelivery.vue?vue&type=template&id=7646f0bd&scoped=true"
import script from "./toDelivery.vue?vue&type=script&lang=js"
export * from "./toDelivery.vue?vue&type=script&lang=js"
import style0 from "./toDelivery.vue?vue&type=style&index=0&id=7646f0bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646f0bd",
  null
  
)

export default component.exports